import { gql } from '@apollo/client';
export default gql`
  query getSalaryPayments(
    $start: Date
    $end: Date
    $departmentId: String
    $employeeId: String
  ) {
    getSalaryPayments(
      start: $start
      end: $end
      departmentId: $departmentId
      employeeId: $employeeId
    ) {
      ok
      error
      count
      data {
        _id
        branch
        autoNo
        docNo
        opType
        title
        desc
        time
        year
        day
        month

        departmentId
        departmentName
        departmentNameAr

        employeeId
        employeeName
        employeeNameAr

        debitAcc
        creditAcc
        amount
        links
        attachments

        userId
        createdAt
        updatedAt
      }
    }
  }
`;
